import { localeSlotsType } from '../en-US'

export const slots: localeSlotsType = {
  popularGames: 'Juegos populares',
  playCasino: 'Jugar casino',
  playPopularGames: 'Juega A Juegos Populares',
  playLiveCasino: 'Juega al casino en vivo',
  exclusive: 'Exclusivo',
  filterBy: 'Filtrar por',
  mostPopular: 'Popularidad',
  orderBy: 'Ordenar por',
  availableTwoGames: 'El funcionamiento paralelo de dos o más juegos para este juego no está disponible',
  demoStart: 'Juega por diversión',
  youWin: 'Tú has ganado',
  sessionEnd: 'Sesión finalizada',
  slots: 'Slots de Casino',
  liveCasino: 'Casino en\u00A0vivo',
  'live-casino': 'Casino en\u00A0vivo',
  'star-casino': 'Casino estrella',
  'free-spin': 'Giro gratis',

  casino: 'Slots de Casino',
  changeOrientation: 'Cambie la orientación de la pantalla',
  goPlay: 'Ve a jugar',
  play: 'Jugar',
  all: 'Todos',
  startPlay: 'Empezar a jugar',
  showAll: 'Mostrar todo',
  virtualGames: 'Juegos virtuales',
  evolution: 'Evolución',
  xpg: 'XPG',
  pleaseAuth: 'Para usar el casino, inicie sesión.',
  popular: 'Popular',
  roulette: 'Ruleta',
  slotMachines: 'Máquinas tragamonedas',
  lotto: 'Lotería',
  cardGames: 'Juegos de cartas',
  searchGames: 'Buscar juegos',
  showProviders: 'Mostrar proveedores',
  goToCasino: 'Ir al casino',
  search: 'Buscar',
  searchSlots: 'Buscar tragamonedas',
  allGames: 'Todos los juegos',
  casinoGames: 'Juegos de casino',
  slotSuccessfullyAdded: 'Ranura agregada con éxito',
  slotSuccessfullyRemoved: 'Ranura eliminada con éxito',
  evoAutoGames: 'Juegos de autos Evo',
  winner: 'Ganador',
  favorites: 'Favoritos',
  favorite: 'Favorito',
  developer: 'Desarrollador',
  nowPlaying: 'Ahora jugando tragamonedas',
  searchGame: 'Juego de búsqueda',
  slotName: 'Nombre de la ranura',
  new: 'Nuevo',
  fruits: 'Frutas',
  games: 'Juegos',
  race: 'Raza',
  tableGames: 'Juegos de mesa',
  hot: 'Caliente',
  wild: 'Salvaje',
  books: 'Libros',
  jokers: 'Comodines',
  egypt: 'Egipto',
  asia: 'Asia',
  megaways: 'Megaways',
  ancient: 'Antiguo',
  wolfs: 'Lobos',
  dragonsAndTigers: 'Dragones Y Tigres',
  luxury: 'Lujo',
  worldOfSea: 'Mundo Del Mar',
  girls: 'Chicas',
  oldSchool: 'Vieja escuela',
  luckyClower: 'Payaso afortunado',
  battles: 'Batallas',
  gangsta: 'Gangsta',
  sport: 'Apuesta Deportiva',
  sweets: 'Dulces',
  fantasy: 'Fantasía',
  tvBet: 'Apuesta de TV',
  learnMore: 'Más información',
  showGames: 'Mostrar Juegos',
  tryVpn: 'Intente habilitar vpn',
  yourFavoritesList: 'Tu lista de tragamonedas favoritas',
  addFavoritesSlots: 'Agréguelos haciendo clic en:',
  addToFavorites: 'Añadir a favoritos',
  removeFromFavorites: 'Eliminar de favoritos',
  showMore: 'Mostrar más',
  showLess: 'Mostrar menos',

  virtual: 'Virtual',
  showFavorites: 'Mostrar solo favoritos',
  provider: 'Proveedor',
  loading: 'Cargando',
  playNow: 'Juega ahora',
  gold: 'Oro',
  silver: 'Plata',
  bronze: 'Bronce',
  jackpot: 'Bote',
}
